export enum MeasureNames {
    OPEN_CHANNEL = 'open_channel',
    OPEN_THREAD = 'open_thread',
    OPEN_APP = 'open_app',
    SEND_MESSAGE = 'send_message',
}
